import { HANDLE_CHANGE_REPORT_CONFIG_SETUP } from "../../../constants";


export const handleChageReportSetup = (payload) => {
    return (dispatch) => {
        dispatch({ type: HANDLE_CHANGE_REPORT_CONFIG_SETUP, payload });
    }
};